<!-- Mobile Menu -->
<div class="responsive-container mobile-menu-shell">
  <!-- Toast Messages -->
  <p-toast position="top-center">
  </p-toast>

  <!-- Header Section -->
  <div class="menu-header">
    <img src="assets/Bild-Portal.svg" alt="Bild" class="menu-logo" />
    <div class="menu-header-text">
      <h1 class="menu-title">Centro de Operaciones</h1>
      <p class="menu-subtitle">Controla tu inventario</p>
    </div>
    <button pButton type="button" class="p-button-text p-button-rounded theme-toggle-btn"
      [icon]="themeService.isDarkMode ? 'pi pi-sun' : 'pi pi-moon'"
      (click)="themeService.toggleDarkMode()" aria-label="Cambiar tema"></button>
  </div>

  <!-- Menu Grid -->
  <div class="menu-grid">
    @for (item of menuItems; track item.label) {
      <button pButton pRipple type="button" class="menu-tile" [severity]="item.severity" [outlined]="true"
        (click)="navigateTo(item.route)">
        <i [class]="item.icon + ' menu-tile-icon'"></i>
        <span class="menu-tile-label">{{ item.label }}</span>
      </button>
    }
  </div>

  <!-- Footer Info -->
  <div class="menu-footer">
    <p class="version-text">Versión 2.0.0</p>
    <button pButton pRipple type="button" severity="danger" [outlined]="true" class="logout-button"
      (click)="logout()">
      <i class="pi pi-sign-out mr-2"></i>
      Cerrar sesión
    </button>
  </div>
</div>
